App.filter('ifEmptyReplaceText', function () {
    return function (el, text) {
        el = el || text;

        return el;
    };
})